import { render, staticRenderFns } from "./educational-platforms.vue?vue&type=template&id=2e164c17&scoped=true&"
import script from "./educational-platforms.vue?vue&type=script&lang=js&"
export * from "./educational-platforms.vue?vue&type=script&lang=js&"
import style0 from "./educational-platforms.vue?vue&type=style&index=0&id=2e164c17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e164c17",
  null
  
)

export default component.exports